// extracted by mini-css-extract-plugin
export default {"root":"SortableTableCellOption_root__VojJv","selected":"SortableTableCellOption_selected__HARW9"};